import { CSSProperties } from 'react';

/**
 * Plain CSS rather than SxProps: this dresses an SVG `<text>` inside the chart surface,
 * where emotion's sx prop does not reach.
 *
 * Text wears text ink, not the series colour. In a grouped chart the label sits directly
 * over its own bar, so position already says which series it belongs to -- colouring it as
 * well would be a second, redundant encoding competing with the bar underneath it.
 */
export const aboveBarLabelTextStyles = (fontSize: number): CSSProperties => ({
    fontSize,
    fontWeight: 600,
    fill: 'rgba(26,26,46,0.72)',
    // So a column of figures keeps its columns rather than shuffling as the values change.
    fontVariantNumeric: 'tabular-nums',
    pointerEvents: 'none',
});
